import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import {
  clientGetEntityData,
  clientGetLocation,
} from "@services/location.service";
import { getValue } from "@utils/lodash";
import "./index.scss";
import Lottie from "lottie-react";
import warehouse from "@lottie/warehouse.json";
import production from "@lottie/production_plant.json";
import building from "@lottie/building.json";
import hospital from "@lottie/hospital.json";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import CommonBulkUpload from "@components/BulkUpload";
import { useNavigate } from "react-router-dom";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import BulkUploadDropdown from "@components/BulkUploadDropdown";
import PEComplianceLicenseNotfound from "@components/Page-Not-Found/pe-compliance-license-not-found";
import MenuActivitySvgComponent from "../../../assets/svg-components/left-menu/menuactivity";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import ListViewSvgComponent from "../../../assets/svg-components/list-view";
import GridViewSvgComponent from "../../../assets/svg-components/grid-view";
import ReactTooltip from "react-tooltip";
import { allParams } from "@_common/common-helper";

export default function TaskLicenseRegion(props: any) {
  let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [complianceTypeList, setComplianceTypeList] = useState([]);
  const [view, setView] = useState("grid");
  const [dropdownOptions] = useState([
    { value: "LICENSES_TASK", label: "License" },
  ]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
    if (getValue(localStorage, `task_license_loc`, "")) {
      localStorage.removeItem("task_license_loc");
    }
    setView(
      getValue(localStorage, `l-view`, "")
        ? getValue(localStorage, `l-view`, "")
        : "grid"
    );
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      is_active: true,
      is_user_request: true,
      group_id: params.group_id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      // let resp = await adminGetListManagementGroupCode("compliance-type");
      let resp = await clientGetEntityData(queryRequest);
      if (resp) {
        // let list = getValue(resp, `data.listItems.length`, 0)>0?getValue(resp, `data.listItems`, []).filter((item:object)=>getValue(item, `is_active`, "")):[]
        // setComplianceTypeList(
        //   getValue(resp, `data.locations`, []).filter((item: object) =>
        //     getValue(item, `is_active`, false)
        //   )
        // );
        setComplianceTypeList(getValue(resp, `data.regions`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const selectAnimation = (value: string) => {
    switch (value) {
      case "Shops and Commercial Establishments":
        return building;
      case "Factory":
        return production;
      case "Warehouse":
        return warehouse;
      case "Health Care":
        return hospital;
      default:
        return building;
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeView = (view: string) => {
    localStorage.setItem("l-view", view);
    setView(view);
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let payload = {
    loc_page_no: getValue(params, `page_no`, "1"),
    loc_search_text: getValue(params, `search_text`, ""),
  };
  let queryRequest = QueryRequestHelper(payload);
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "activities_licenses"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex justify-content-between align-items-center">
            {/* <h4 className="dashbaord-wrapper__header-title">License</h4> */}

            <div className="d-flex align-items-center">
              <NavLink to={`/activities/task/license/group`} className="me-2">
                <img
                  src="/images/back-link.svg"
                  className="img-fluid add-filter-wrapper__upload-image"
                />
              </NavLink>
              <div className="header-parent-icon-holder">
                <MenuActivitySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Activities
                </h6>
                <h4 className="dashbaord-wrapper__header-title">License</h4>
              </div>
            </div>

            <div className="d-flex align-items-center sub-header-icons-holder">
              <div>
                <RightMenuHeaders
                  isSearch={true}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  lineSeperator={true}
                />
              </div>
              {getValue(props, `permissions`, []).includes("update") && (
                <div style={{ margin: "0 2px" }}>
                  {/* <CommonBulkUpload
									type={`license`}
									url={`
								https://asccuriodata.s3.ap-south-1.amazonaws.com/documents/Back_dated_task_import_format.xlsx
								`}
								/> */}
                  {/* https://asccuriodata.s3.ap-south-1.amazonaws.com/templates/Task%20Import%20Template.xlsx */}
                  {/* <BulkUploadDropdown
                    url={
                      "https://asccuriodata.s3.ap-south-1.amazonaws.com/documents/Back_dated_task_import_format.xlsx"
                    }
                    dropdownOptions={dropdownOptions}
                  /> */}
                </div>
              )}
              <ReactTooltip id="viewModeLicense" effect="solid" place="bottom">
                {view === "list" ? <>List View</> : <>Grid view</>}
              </ReactTooltip>
              <div
                className="icons-btn cursor-pointer"
                onClick={() =>
                  handleChangeView(view === "list" ? "grid" : "list")
                }
                data-tip
                data-for="viewModeLicense"
              >
                {view === "list" ? (
                  <ListViewSvgComponent />
                ) : (
                  <GridViewSvgComponent />
                )}
                {/* <img
                  src={`/images/${view === "list" ? "grid" : "list"}.png`}
                  style={{ height: "30px", width: "30px" }}
                /> */}
              </div>
            </div>
          </div>

          <div className="compliance-wrapper license-module-main-wrapper">
            <div className="compliance-banner d-flex align-items-center justify-content-around">
              {/* <img
								src="/images\tasks\banner-image-1.svg"
								className="img-fluid"
							/> */}
              {/* <div className="compliance-wrapper__heading text-center">
								<h2 className="compliance-wrapper__title">
									Automated Statutory Compliance Management and Online Statutory
									Audits
								</h2>
							</div> */}
              {/* <img
								src="/images/tasks/banner-image-2.svg"
								className="img-fluid"
							/> */}
            </div>

            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/configuration/vendors/add"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  add={"false"}
                />
              </div>
            </div>

            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : getValue(complianceTypeList, `length`, 0) > 0 ? (
              view === "grid" ? (
                <div className="compliance-wrapper__categories-license">
                  {complianceTypeList.map((categoriesObj, index: any) => {
                    return (
                      <div
                        className="compliance-wrapper__categories-details_license cursor-pointer"
                        key={index}
                      >
                        <NavLink
                          to={`/activities/task/license?${queryRequest}&group_id=${getValue(
                            params,
                            `group_id`,
                            ""
                          )}&region_id=${getValue(
                            categoriesObj,
                            `regionId`,
                            ""
                          )}`}
                        >
                          <div className="d-flex align-content-center margin">
                            <div className="lottie-wrapper">
                              <Lottie
                                animationData={selectAnimation(
                                  getValue(
                                    categoriesObj,
                                    `business_type.text`,
                                    ""
                                  )
                                )}
                                autoplay={true}
                              />
                            </div>
                            <div style={{ marginLeft: "16px" }}>
                              <h4 className="compliance-wrapper__categories-title align-center">
                                {getValue(categoriesObj, `regionName`, "")}
                              </h4>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <div className="compliance-wrapper__categories-license-list">
                  {complianceTypeList.map((categoriesObj, index: any) => {
                    return (
                      <div
                        className="compliance-wrapper__categories-details_license-list cursor-pointer"
                        key={index}
                      >
                        <NavLink
                          to={`/activities/task/license?${queryRequest}&group_id=${getValue(
                            params,
                            `group_id`,
                            ""
                          )}&region_id=${getValue(
                            categoriesObj,
                            `regionId`,
                            ""
                          )}`}
                        >
                          <div className="d-flex align-content-center margin">
                            <div className="lottie-wrapper">
                              <Lottie
                                animationData={selectAnimation(
                                  getValue(
                                    categoriesObj,
                                    `business_type.text`,
                                    ""
                                  )
                                )}
                                autoplay={true}
                              />
                            </div>
                            <div style={{ marginLeft: "16px" }}>
                              <h4 className="compliance-wrapper__categories-title align-center">
                                {getValue(categoriesObj, `regionName`, "")}
                              </h4>
                            </div>
                          </div>
                        </NavLink>
                      </div>
                    );
                  })}
                </div>
              )
            ) : (
              <PEComplianceLicenseNotfound />
            )}
          </div>
          <div className="footer-wrapper d-flex justify-content-between">
            {complianceTypeList.length > 0 && (
              <img
                src="/images/building-illustration.svg"
                className="img-fluid"
              />
            )}
            {totalCount > 10 ? (
              <PaginationPage
                totalCount={totalCount}
                limit={limit}
                pageNumber={page_no}
                handleChangePagination={handleChangePagination}
                handleChangeLimit={handleChangeLimit}
                showLimit={"false"}
              />
            ) : (
              <p className="show-rows-count mt-3 d-flex">
                Total Count:&nbsp;&nbsp;{" "}
                <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
              </p>
            )}
          </div>
        </>
      )}
    </DashboardLayout>
  );
}
